import React from 'react';
import { SvgIcon } from '@mui/material';

export default function MenuIconHome(props) {
  const { iconcolor } = props;
  return (
    <SvgIcon {...props} color="inherit" width="17" height="12" viewBox="0 0 17 12">
      <path d="M7.92812 4.42077V10.8928H1.32812V4.42077L4.62812 1.38477L7.92812 4.42077Z" fill="#004C3B" />
      <path d="M7.92813 4.42077V10.8928H1.32812V4.42077L4.62813 1.38477L7.92813 4.42077Z" fill={iconcolor} />
      <path d="M15.6718 4.24477H8.32777L5.21777 1.38477H12.5598L15.6718 4.24477Z" fill={iconcolor} />
      <path d="M5.66175 6.80859H3.59375V10.8926H5.66175V6.80859Z" fill="white" />
      <path d="M5.25977 10.891V7.20703H3.99177V10.891H5.25977Z" fill="#004C3B" />
      <path d="M8.32812 4.64453V10.8925H15.6721V4.64453H8.32812ZM13.1061 6.20853V6.78853H10.8941V6.20853H13.1061ZM9.40013 6.20853H10.4941V6.78853H9.40013V6.20853ZM9.40013 7.76853V7.18853H10.4941V7.76853H9.40013ZM10.8941 7.76853V7.18853H13.1061V7.76853H10.8941ZM14.6001 7.76853H13.5061V7.18853H14.6001V7.76853ZM14.6001 6.78853H13.5061V6.20853H14.6001V6.78853Z" fill={iconcolor} />
      <path d="M16.4723 11.692H0.52832V4.06798L4.31632 0.583984H12.8763L16.4723 4.15998V11.692ZM0.92832 11.292H16.0723V4.32798L12.7123 0.983984H4.47232L0.92832 4.24398V11.292Z" fill={iconcolor} />
    </SvgIcon>
  );
}
